import * as React from "react";
function EllipsisHorizontalIcon(props) {
    return React.createElement("svg", { fill: "none", viewBox: "0 0 20 20", height: "1em", width: "1em", ...props },
        React.createElement("path", { fill: "currentColor", d: "M5 10a2 2 0 1 1-3.999.001A2 2 0 0 1 5 10m7 0a2 2 0 1 1-3.999.001A2 2 0 0 1 12 10m5 2a2 2 0 1 0 .001-3.999A2 2 0 0 0 17 12" }));
}
export default EllipsisHorizontalIcon;
//# sourceMappingURL=EllipsisHorizontal.js.map